<template>
  <div class="exr-item flex-row">
    <div class="flex1 exr-image-wrap">
      <img :src="imgUrl" alt=""/>
    </div>
    <el-input class="flex2" type="textarea" v-model="value.imageDesc" placeholder="输入图片描述" v-popover:filepreview></el-input>
    <el-popover
        ref="filepreview"
        placement="bottom-start"
        width="500"
        trigger="click">
      <FilePreview :src="imgUrl"></FilePreview>
    </el-popover>
  </div>
</template>

<script>
import utils from "@/js/utils.js";
import FilePreview from "@/components/filemanager/FilePreview.vue";

export default {
  name: "PdtItemImage",
  components: {FilePreview},
  props: {
    value: Object,
  },
  computed: {
    imgUrl() {
      return utils.url(this.value.image)
    }
  },
  methods: {
    getFileUrl(file) {
      return utils.url(file)
    }
  }
}
</script>
<style lang="scss" scoped>
.exr-image-wrap {
  border-right: 1px solid #DCDFE6;
}
.exr-item::v-deep {
  textarea {
    border: 0;
    height: 81px !important;
    padding-left: 8px;
  }
}
</style>